import React from "react";

export default function WorkExperience() {
  return (
    <section id="workexperience">
    <div className="container px-5 py-10 mx-auto">
      <div className="mb-20">
        <h1 className="text-center title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
          Work Experience
        </h1>
        <h2 className="text-center title-font sm:text-lg text-3xl mb-4 font-normal text-white">
          SingSing Bar - Owner & Manager (July 2014 – March 2020)
        </h2>
        <h3 className="grid grid-cols-2 grid-flow-row gap-2">
          <p className="mb-8 leading-relaxed font-semibold">
            Responsibilities
              <ul className= "font-light">
                <li>- Responsible for communicating with customers to ensure high customer satisfaction and retention</li>
                <li>- Oversaw finances to make sure revenue projections were being met</li>
                <li>- Researched and analysed latest products and trends in order to continuously adapt business</li>
                <li>- Negotiated with suppliers to secure best pricing and maintain strong relationship</li>
                <li>- Supervised and trained staff, managing up to six at one time</li>
                <li>- Planned and organised viewings of sporting events and comedy nights for up to 150 people</li>
                <li>- -	Handled both offline and online marketing, including social media, promotional schemes and events</li>
              </ul>
            </p>
          <p className="mb-8 leading-relaxed font-semibold">
            Achievements
              <ul className= "font-light">
                <li>-	Started a successful business from the ground up, while wearing every hat of the company</li>
                <li>-	Demonstrated resilience and perseverance to turn a previously unknown bar into the go-to place</li>
                <li>-	Revenue increased annually by 50%</li>
                <li>-	Daily requirement to motivate myself and take initiative in building a business whilst learning the trade myself</li>
              </ul>
          </p>
        </h3>
      </div>
    </div>
  </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/WorkExperience.js